export const VALIDATIONS_TYPES = {
  DUPLICATES: 'duplicates',
  EMPTY_CELL: 'emptyCell',
  LENGTH: 'length',
  TOTAL: 'total',
};
